export const state = () => ({
	invoices: null,
	from_date: null,
	to_date: null,
});

export const mutations = {
	setInvoices(state: any, payload: any) {
		state.invoices = payload;
	},

	setFromDate(state: any, payload: any) {
		state.from_date = payload;
	},

	setToDate(state: any, payload: any) {
		state.to_date = payload;
	},
};

export const getters = {
	getInvoices: (state: any) => state.invoices,

	getFromDate: (state: any) => state.from_date,

	getToDate: (state: any) => state.to_date,
};

export const actions = {
	getInvoices(state: any) {
		const company_uuid = this.$auth.user.company.uuid;

		return new Promise((resolve, reject) => {
			this.$axios
				.get(`/api/company/${company_uuid}/statement`, {
					params: {
						from_date: state.state.from_date,
						to_date: state.state.to_date,
					},
				})
				.then((res) => {
					state.commit('setInvoices', res.data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setInvoices(state: any, payload: any) {
		state.commit('setInvoices', payload);
	},

	setFromDate(state: any, payload: any) {
		state.commit('setFromDate', payload);
	},

	setToDate(state: any, payload: any) {
		state.commit('setToDate', payload);
	},
};
